(function ($) {
	function seconds_to_text(seconds) {
		let output = [];
		if (seconds > 0) {
			const s_in_day = 60 * 60 * 24;
			let d = Math.floor(seconds / s_in_day);
			d > 0 && output.push(d + 'd');

			const s_in_hour = 60 * 60;
			let h = Math.floor((seconds - d * s_in_day) / s_in_hour);
			h > 0 && output.push(h + 'h');

			let m = Math.floor((seconds - d * s_in_day - h * s_in_hour) / 60);
			m > 0 && output.push(m + 'm');

			let s = Math.floor((seconds - d * s_in_day - h * s_in_hour - m * 60));
			s > 0 && output.push(s + 's');
		}
		return output.join(' ');
	}

	function setScrollbarWidth() {
		// Creating invisible container
		const outer = document.createElement('div');
		outer.style.visibility = 'hidden';
		outer.style.overflow = 'scroll'; // forcing scrollbar to appear
		outer.style.msOverflowStyle = 'scrollbar'; // needed for WinJS apps
		document.body.appendChild(outer);

		// Creating inner element and placing it in the container
		const inner = document.createElement('div');
		outer.appendChild(inner);

		// Calculating difference between container's full width and the child width
		const scrollbarWidth = (outer.offsetWidth - inner.offsetWidth);

		// Removing temporary elements from the DOM
		outer.parentNode.removeChild(outer);

		$(':root').css('--scrollbar-width', `${scrollbarWidth}px`, '0px');
	}

	function changeStatusBtnText(label, open, close) {
		if (label.length > 0) {
			label.text().trim() === open ? label.html(close) : label.html(open);
		}
	}

	var isMobile = setIsMobile($(window).width());

	function setIsMobile(width) {
		return width < 768;
	}

	$(window).resize(function () {
		isMobile = setIsMobile($(window).width());
	});

	//Add offers calendar overlay if today offer block is exist
	if ($('.offer-today').length > 0) {
		$('.offers-calendar-overlay').show();
	}

	//Popup and accordion logic
	$('.card--open .stretched-button').on('click', function (event) {
		event.preventDefault();
		let statusBtn = $(this).prev('.status'),
				offerInfo = statusBtn.closest('.card-wrapper').find('.offer-details'),
				statusLabel = statusBtn.find('span').not('.status-icon'),
				statusTextOpen = statusLabel.data('open'),
				statusTextClose = statusLabel.data('close');

		if (isMobile) {
			statusBtn.toggleClass('rotate');
			offerInfo.slideToggle();
			offerInfo.toggleClass('open')
		} else {
			statusBtn.removeClass('rotate');
			offerInfo.toggleClass('open');
		}
		changeStatusBtnText(statusLabel, statusTextOpen, statusTextClose);
		$('body').toggleClass('offer-details-show');
	});

	//Add shake animation at upcomig cards
	$('.card--upcoming .stretched-button').on('click', function (event) {
		event.preventDefault();
		let statusBtn = $(this).prev('.status');

		statusBtn.addClass('shake');
		setTimeout(function () {
			statusBtn.removeClass('shake');
		}, 1000)
	});

	//Popup logic
	$('.offer-close').on('click', function (event) {
		event.preventDefault();
		let offerInfo = $(this).closest('.offer-details'),
				statusBtn = offerInfo.parent('.card-wrapper').find('.card .status span').not('.status-icon'),
				statusTextOpen = statusBtn.data('open'),
				statusTextClose = statusBtn.data('close');

		$(this).closest('.card-wrapper').find('.status').removeClass('rotate');
		changeStatusBtnText(statusBtn, statusTextOpen, statusTextClose);
		$('body').removeClass('offer-details-show');
		offerInfo.removeClass('open');
		$('.offers-calendar-overlay').hide();
	});

	//Start timer
	$('.completion-time').each(function () {
		let timer = $($(this).find('span'));
		let seconds = $(this).data('countdown');
		setInterval(function () {
			seconds -= 1;
			timer.html(seconds_to_text(seconds));
		}, 1000);
	});

	//Set css variable scrollbar width
	setScrollbarWidth();

	//Hover status icon with stretched button
	$('.offers-calendar .card--open .stretched-button').hover(
		function () { $(this).parent().addClass('hover'); },
		function () { $(this).parent().removeClass('hover'); }
	);
}(jQuery));